import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from './state';
import {
  FEATURE_KEY,
  AssignmentStatusTypes,
  getAssignmentStatusCodeError,
  AssignmentStatus,
  AssignmentStatusMessageTypes,
} from './constants';
import { LabAffiliation } from '../data/models/lab-affiliation.model';
import { isNullOrUndefined } from 'util';
import * as _ from 'lodash';

export const selectClaimCmeCeSlice = createFeatureSelector<State>(FEATURE_KEY);

export const getLabAffiliations$ = createSelector(
  selectClaimCmeCeSlice,
  (state: State): LabAffiliation[] => state.labAffiliations
);

export const hasAffiliations$ = createSelector(
  selectClaimCmeCeSlice,
  (state: State): boolean =>
    state.labAffiliations && state.labAffiliations.length > 0
);

export const getDerivedOrganization$ = createSelector(
  selectClaimCmeCeSlice,
  (state: State): LabAffiliation => _.get(state, 'derivedLabAffiliation', null)
);

export const showConfirmation$ = createSelector(
  selectClaimCmeCeSlice,
  (state: State): boolean => state.showConfirmation
);

export const showHelp$ = createSelector(
  selectClaimCmeCeSlice,
  (state: State): boolean => state.showHelp
);

export const getContextualHelpHTML$ = createSelector(
  selectClaimCmeCeSlice,
  (state: State): string => state.contextualHelpHTML
);

export const getAssignmentStatus$ = createSelector(
  selectClaimCmeCeSlice,
  (state: State): AssignmentStatusTypes => state.assignmentStatus
);

export const getSurveyName$ = createSelector(
  selectClaimCmeCeSlice,
  (state: State): string => {
    const mailingCode = _.get(state, 'activityValidation.mailingCode', null);

    // if (!mailingCode || mailingCode.length === 0) {
    //     return 'this survey';
    // }

    return mailingCode;
  }
);

export const getActivityId$ = createSelector(
  selectClaimCmeCeSlice,
  (state: State): string => _.get(state, 'activityValidation.activityId', null)
);

export const getActivityCode$ = createSelector(
  selectClaimCmeCeSlice,
  (state: State): string =>
    _.get(state, 'activityValidation.activityCode', null)
);

export const getActivityRedirectUrl$ = createSelector(
  selectClaimCmeCeSlice,
  (state: State): string => state.activityRedirectUrl
);

export const getAssignmentStatusCode$ = createSelector(
  selectClaimCmeCeSlice,
  (state: State): string =>
    _.get(state, 'activityValidation.validationCode', null)
);

export const getAssignmentStatusCodeMessage$ = createSelector(
  selectClaimCmeCeSlice,
  (state: State): string => {
    const status = _.get(
      state,
      'activityValidation.validationCode',
      ''
    ).toString();
    const error = getAssignmentStatusCodeError(status);

    return error.message;
  }
);

export const getAssignmentStatusCodeMessageType$ = createSelector(
  selectClaimCmeCeSlice,
  (state: State): AssignmentStatusMessageTypes => {
    const status = _.get(
      state,
      'activityValidation.validationCode',
      ''
    ).toString();
    const error = getAssignmentStatusCodeError(status);

    return error.type;
  }
);

export const hasError$ = createSelector(
  selectClaimCmeCeSlice,
  (state: State): boolean => !isNullOrUndefined(state.error)
);
